import * as Sentry from '@sentry/browser'
import router from '@router'

const debug = process.env.VUE_APP_ENV !== 'production'

export default {
  state: {
    host: window.location.hostname,
    preview: window.location.search,
    siteLoaded: false,
    site: {},
  },

  getters: {
    getHost: (state, getters) => {
      const previewHost = getters.getPreview
      let host = (debug && previewHost) || state.host
      if (host.includes('www.')) host = host.slice(4, host.length)
      if (debug) {
        console.log(`Is Dev: ${debug}`)
        console.log(`Preview: ${previewHost || 'none'}`)
      }
      return host
    },
    getPreview: (state) => {
      const urlParams = new URLSearchParams(state.preview)
      return urlParams.get('preview')
    },
  },

  actions: {
    async initApp({ commit, dispatch, getters }) {
      try {
        const host = getters.getHost
        await dispatch('contentful/getAndSetGlobalContentAndBrand', { host })

        const appIsEnabled = getters['contentful/globallyEnabled']
        if (!appIsEnabled) {
          return router.push({
            name: 'unavailable',
            params: { code: 'killswitch:global' },
          })
        }
        const brandIsEnabled = getters['contentful/brandEnabled']
        if (!brandIsEnabled) {
          return router.push({
            name: 'unavailable',
            params: { code: 'killswitch:brand' },
          })
        }

        const brandId = getters['contentful/brandId']
        if (!brandId) {
          Sentry.withScope((scope) => {
            scope.setTag('Contentful')
            Sentry.captureException(new Error(`No brand ID for ${host}`))
          })

          return router.push({
            name: 'unavailable',
            params: { code: 'error:brandId' },
          })
        }
        commit('payment/setBrandId', brandId)

        const brandName = getters['contentful/brandName']
        if (!brandName) {
          Sentry.withScope((scope) => {
            scope.setTag('Contentful')
            Sentry.captureException(new Error(`No brand name for ${host}`))
          })

          return router.push({
            name: 'unavailable',
            params: { code: 'error:brandName' },
          })
        }
        commit('payment/setBrandName', brandName)
      } catch (err) {
        console.log(err)
        Sentry.withScope((scope) => {
          scope.setTag('initApp')
          Sentry.captureException(err)
        })

        const contentfulLoadingStatus =
          getters['contentful/contentfulLoadingStatus']

        if (contentfulLoadingStatus !== 'loaded') {
          commit('setContentfulLoadingStatus', 'error')
        }

        return router.push({
          name: 'unavailable',
          params: { code: `error:${err.message}` },
        })
      }
    },
  },

  mutations: {
    setSiteLoaded(state) {
      state.siteLoaded = true
    },
  },
}
